module.exports = __webpack_public_path__ + "img/pf.pf60eab75.svg";